const benefitModule = {
  // other module props
  id: "78d10a8b-610b-3e16-97a9-33b546d000e6",
  config: {
    icon: {
      iconColor: {
        label: "Green",
        value: "#008000",
      },
      name: "house",
      showBackgroundColor: true,
    },
    header: {
      isTextInCaps: false,
      text: "Hello to All",
      textColor: {
        label: "Black 4",
        value: "#444444",
      },
    },
    text: {
      text: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Fuga hic tempore neque tenetur nesciunt! Voluptates doloribus, placeat natus ducimus facilis commodi recusandae. Praesentium officiis odio unde ad placeat quos quas. ",
      textColor: {
        label: "Silver",
        value: "#86868B",
      },
    },
  },
};

export default benefitModule;
